import Actions from "../actions";
import type { UserType } from "../types";
import Navigation from "./navigation";

interface LeftSidebarProps {
  user: UserType;
}

export default function LeftSidebar({ user }: LeftSidebarProps) {
  return (
    <>
      <Actions user={user} />
      {!user.isBlocked && <Navigation user={user} />}
    </>
  );
}
